/**
 * @fileoverview PATCH handler for the "/apps/user_info/update_click_through_tracking_config" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoUpdateClickThroughTrackingConfigCacheKeys } from "./constants";
import type {
  AppsUserInfoUpdateClickThroughTrackingConfigResult,
  PatchUpdateClickThroughTrackingConfigProps,
} from "./types";

export const patchAppsUserInfoUpdateClickThroughTrackingConfig = reactQueryMutationAdapter(
  appsUserInfoUpdateClickThroughTrackingConfigCacheKeys,
  (
    props: PatchUpdateClickThroughTrackingConfigProps
  ): Promise<AppsUserInfoUpdateClickThroughTrackingConfigResult> => {
    return fetch("/apps/user_info/update_click_through_tracking_config", "PATCH", {
      click_through_tracking_enabled: props.click_through_tracking_enabled,
    });
  }
);
